import { useState, useEffect } from "react";
import {} from "react-router-dom";

const useLocation = (location, history, matchers, matchLevel) => {
  matchLevel = matchLevel + 1 || 2;
  // slice(0,2) means one level
  const [current, setCurrent] = useState(
    location &&
      location.pathname
        .split("/")
        .slice(0, matchLevel)
        .join("/")
  );

  useEffect(() => {
    // check url on mount
    if (location && location.pathname) {
      const loc = location.pathname
        .split("/")
        .slice(0, matchLevel)
        .join("/");

      if (!decodeURI(matchers).includes(loc) && loc !== "/") {
        // if location doesn't match given pathnames or "/"
        // either give user a 404 page or bring them back to main page
        console.log("no match!: ", location);
        // alert(
        //   "this page does not exist! TODO: create custom 404 here or reroute to main page"
        // );
      } else {
        setCurrent(loc);
        // TODO: use withRouter from react router 4
        // history.push(loc);
      }
    }
  }, [location, matchLevel, matchers]);

  return [current, setCurrent];
};

export default useLocation;
